<!--
    Created by 程雨喵'mac on 2024/4/11.
    Copyright © 2024年 云柜-金星晖. All rights reserved.
    界面名称：外部数据-导入设备数据
-->
<style lang="less">
#outside-import-device {
  .top-tab-outer {
    margin: -@containerGap -@containerGap @containerGap * 0.5;
    background-color: @backColorNormal;
  }
  .text-color-error {
    color: @errorColor;
    font-weight: 600;
  }
}
</style>

<template>
  <section id="outside-import-device">
    <div class="top-tab-outer">
      <yg-tab-primary
        :dic-items="tab.items"
        :index="tab.index"
        :type="3"
        @on-change="onTabChange"
      />
    </div>
    <div class="outside-page-content">
      <!-- 查询条件 -->
      <div
        v-if="tab.items.length"
        v-permission="'system:importDevice:list'"
      >
        <yg-search-area
          :show-info="false"
          :value="searchOption"
          @on-search="_clickSearch"
        />
      </div>
      <div>
        <yg-setting-area
          :items="settingItems"
          :total="page.total"
          :export-amount="settingExportIdList.length"
          :export-select-id-list="settingExportIdList"
          :export-condition="settingExportCondition"
          @on-click="_clickSetting"
        />
      </div>
      <div
        class="padding-primary-top"
      >
        <yg-table
          :columns="tableColumns"
          :data="tableData"
          :page="page"
          @on-page-change="onChangePage"
          @on-selection="onChangeSelection"
        />
      </div>
    </div>
    <!--导入弹窗-->
    <v-submit
      v-if="!!dialog.submitModel"
      :model="dialog.submitModel"
      title="设备台账"
      :submit-type="pageType"
      @on-close="dialog.submitModel=null"
      @on-sure="onSureSubmit"
    />
  </section>
</template>

<script>
import vSubmit from './view/submit.vue';
import { OutsideImportDataModel, OutsideImportFormModel } from './model/OutsideImportDataModel';
import controllerMix from './mixins/controller';
import OutSideDataApiSet from '@/request/api/OutSideDataApiSet';
import { downloadExcel } from '@/libs/download';
import { mapActions } from 'vuex';

const PAGE_TYPE = 'outsideDeviceDataType';
export default {
  components: { vSubmit },
  mixins: [controllerMix],
  data () {
    return {
      tab: {
        items: [],
        index: 0
      },
      pageType: '',
      searchOption: {
        // externalChannelType: BaseSearchModel.initData('外部渠道', 'externalChannelType', 'YgGlobalSelect').setData('outsideChannel'),
        // externalDataType: BaseSearchModel.initData('外部数据类型', 'externalDataType', 'YgGlobalSelect').setData(PAGE_TYPE),
        importDate: BaseSearchModel.initData('导入日期', 'importDate', 'DatePickerRange').setDatePickerElevator([])
      },
      // settingItems: [
      //   BaseSettingModel.initData('导入数据', 'add', '').setPermission('system:importDevice:import'),
      //   BaseSettingModel.initData('导出记录表', 'aaa', '').setPermission('system:importDevice:export').setExport().setExportReportType(14)
      // ],
      dialog: {
        submitModel: null
      }
    };
  },
  computed: {
    settingItems () {
      if (this.tab.index === 0) {
        // 小橙
        return [
          BaseSettingModel.initData('导入数据', 'add', '').setPermission('system:importDevice:import'),
          BaseSettingModel.initData('导出记录表', 'aaa', '').setPermission('system:importDevice:export').setExport().setExportReportType(14)
        ];
      }
      return [
        BaseSettingModel.initData('导入数据', 'add', '').setPermission('system:importDevice:import'),
        BaseSettingModel.initData('导出记录表', 'aaa', '').setPermission('system:importDevice:export').setExport().setExportReportType(16)
      ];
    }
  },
  created () {
    this.pageType = PAGE_TYPE;
    this.initData();
  },
  methods: {
    ...mapActions(['getOutsideDeviceDataTypeList']),
    /** ******************* 工具方法开始 ******************* **/
    initData () {
      const items = [];
      this.getOutsideDeviceDataTypeList().then(res => {
        res.forEach(v => {
          items.push(v);
        });
        this.tab.items = items;
      });
    },
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onSureSubmit (params) {
      this.requestImport(params);
    },
    onTabChange (i) {
      if (this.tab.index !== i) {
        this.tab.index = i;
        this.onChangePage(1);
      }
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSetting (key) {
      if (key === 'add') {
        const model = OutsideImportFormModel.createAdditionModel();
        model.externalDataType = this.tab.items[this.tab.index].value;
        // model.externalChannelType = this.tab.items[this.tab.index].value;
        this.dialog.submitModel = model;
      }
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    requestData () {
      this.tableData = [];
      this.page.total = 0;
      const api = OutSideDataApiSet.qryImportData;
      const s = this.searchOption;
      api.params = {
        // externalChannelType: this.tab.items[this.tab.index].value,
        // externalDataType: this.tab.items[this.tab.index].value,
        externalDataType: this.tab.items[this.tab.index].value,
        importDateBegin: s.importDate.value[0] || '',
        importDateEnd: s.importDate.value[1] || '',
        pageSize: this.$config.pageSize,
        pageNo: this.page.current
      };
      this.settingExportCondition = api.params;
      this.$http(api).then(res => {
        const resData = res.data;
        this.page.total = resData.total;
        this.tableData = OutsideImportDataModel.initListWithDataList(resData.rows);
        OutsideImportDataModel.checkModelIsSelect(this.tableData, this.settingExportIdList);
      });
    },
    requestDownload (params, title) {
      const api = OutSideDataApiSet.downloadDeviceResult;
      api.params = params;
      downloadExcel(api.url, api.params, title).then().catch(e => {
        this.$Message.warning(e);
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
